import { jwtDecode } from "jwt-decode";
import { clearImpersonationCookie } from "@/shared/helper/impersonationCookie.helper";
import { isDevelopment } from "@/shared/helper/environment.helper";
import type { DecodedJwt } from "@/shared/auth/@types/DecodedJwt";
import { getJwt } from "./getJwt.helper";

export const isSuperUser = async () => {
  if (isDevelopment) return true;

  const jwt = await getJwt();
  if (!jwt) return false;

  const decodedIdToken = jwtDecode<DecodedJwt>(jwt);
  const superuser = decodedIdToken?.custom_attributes?.superuser;

  // The value of superuser is a string containing "true" or "false"
  const isSuperUser = superuser?.toLowerCase() === "true";

  if (!isSuperUser) clearImpersonationCookie();

  return isSuperUser;
};
